export const environment = {
    smartPortalApiUrl: 'https://app-seh-prd-uks-101.azurewebsites.net/api/',
    seedFunctionApiUrl: 'https://localhost:7210/api/',
    msalConfig: {
        auth: {
            clientId: 'c8de7f2e-f8b5-4bf4-94a9-6c87dbbad84c',
            authority: 'https://login.microsoftonline.com/organizations',
            redirectUri: 'https://seh.icshosting.net/auth',
        },
    },
    apiConfig: {
        scopes: ['api://cc318d2b-1ab0-4cc0-9d59-416b07724ddb/access_as_user'],
        uri: 'https://app-seh-prd-uks-101.azurewebsites.net/',
    }
};
